const LINK_ACCOUNT_PHONE_NUMBER_PREFIX = "lav";

export const LINK_ACCOUNT_PHONE_NUMBER_TEST_IDS = {
    CONTAINER: `${LINK_ACCOUNT_PHONE_NUMBER_PREFIX}_container`,
    TITLE: `${LINK_ACCOUNT_PHONE_NUMBER_PREFIX}_title`,
    SUB_TITLE: `${LINK_ACCOUNT_PHONE_NUMBER_PREFIX}_subtitle`,
    METHOD_ICON: `${LINK_ACCOUNT_PHONE_NUMBER_PREFIX}_icon`,
    PHONE_NUMBER_INPUT: `${LINK_ACCOUNT_PHONE_NUMBER_PREFIX}_phone_number_input`,
    CONFIRM_LINKING_BUTTON: `${LINK_ACCOUNT_PHONE_NUMBER_PREFIX}_confirm_linking`,
    REGISTERED_NUMBER_FIELD: `${LINK_ACCOUNT_PHONE_NUMBER_PREFIX}_registered_number_field`,
};
